import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IAppConfig } from '../core/models/app-config.model';
import { AppConfigService } from '../core/services/app-config.service';

@Injectable({
    providedIn: 'root'
})
export class UpdateEmailAddressService {
     appConfig: IAppConfig = {} as IAppConfig;
     baseUrl: string;

    constructor(private readonly http: HttpClient ,private readonly appConfigService: AppConfigService) { 
         this.appConfig = this.appConfigService.get();
         this.baseUrl = this.appConfig.updateCountryMailbox.baseUrl;
    }
    public saveNewEmail(newEmailDetails: any): Observable<any> {
        const updateEmail = this.appConfig.updateCountryMailbox.updateCountryMailbox;
        const apiUrl: string = `${this.baseUrl + updateEmail}`;
        return this.http.post(apiUrl, newEmailDetails).pipe(
            catchError(error => this.handleError(error))
        );
        //  let aapiUrl: string = '/api/account/UpdateCountrymailbox';
        //  console.log(newEmailDetails)
        //   return this.http.post(MANAGE_COUNTRY_MAILBOX.UPDATE_COUNTRY_MAIL_BOX, newEmailDetails).pipe(
        //      map(res => {
        //          return res;
        //      })
        //  );
    }
    private handleError(error: HttpErrorResponse) {
        if (error.status === 400) {
            return of('N');
        }
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(() => 'Something bad happened; please try again later.');
    }
}
